export default __webpack_public_path__ + "static/media/dancing.98c69a31.jpg";